import { Injectable } from '@angular/core';
import { State, StateToken, Action, StateContext } from '@ngxs/store';
import { RefreshState } from '../refresh/refresh-actions';
import { SetJobTypes } from './job-type-action';

export const JOB_TYPE_TOKEN = new StateToken<any[]>('JobType');

@State({
    name: JOB_TYPE_TOKEN,
    defaults: []
})
@Injectable()
export class JobTypeState {
    @Action(RefreshState)
    refresh(ctx: StateContext<any>, action: RefreshState) {
        if (action.data.name === JOB_TYPE_TOKEN.getName()) {
            ctx.setState(action.data.state);
        }
    }

    @Action(SetJobTypes)
    set(ctx: StateContext<any>, action: SetJobTypes) {
        ctx.setState(action.data);
    }
}
